import { render, staticRenderFns } from "./InviteUniMates.vue?vue&type=template&id=12591088&scoped=true&"
import script from "./InviteUniMates.vue?vue&type=script&lang=js&"
export * from "./InviteUniMates.vue?vue&type=script&lang=js&"
import style0 from "./InviteUniMates.vue?vue&type=style&index=0&id=12591088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12591088",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
